import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=a2436426&scoped=true"
import script from "./LazyImage.vue?vue&type=script&lang=js"
export * from "./LazyImage.vue?vue&type=script&lang=js"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=a2436426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2436426",
  null
  
)

export default component.exports